import { CreateFormatFolderParams } from "@common/actions/formats";
import { MessageProps } from "@common/components/MessageBox.types";
import { FolderPrimaryListDto } from "@common/dto/folder/primary-list-dto";

export enum QueryManagementType {
  load = "load",
  edit = "edit",
}

export type QueryManagementFormat = { id: number | string; name: string; description: string; folderId: string; imageURL: string; };

export type FormatInfo = { searchKeyword?: string; folder?: FolderPrimaryListDto; format: QueryManagementFormat }

export type QueryManagementProps = {
  onClose: () => void;
  showErrorMessage: (message: string) => void;
  showInfoMessage: (message: string, props?: MessageProps) => void;
  withSearch?: boolean;
  getFolders: (params: { context: number }) => Promise<FolderPrimaryListDto[]>;
  getFormats: (params: {
    searchKeyword?: string;
    folder?: FolderPrimaryListDto;
    context?: number;
  }) => Promise<QueryManagementFormat[]>;
  onSubmit: (params: {
    searchKeyword?: string;
    folder?: FolderPrimaryListDto;
    format: QueryManagementFormat;
  }) => void;
  createFormatFolder: (params: CreateFormatFolderParams) => Promise<void>;
  deleteFormatFolder: (params: {
    folderId: FolderPrimaryListDto["id"];
  }) => Promise<void>;
  deleteFormat: (params: {
    formatId: QueryManagementFormat["id"];
    context: number;
  }) => Promise<void>;
  getId: {
    creatingFolderName?: string;
    creatingFolderItem?: string;
    creatingFolderCollapseItem?: string;
    creatingFolderCancelBtn?: string;
    creatingFolderCreateBtn?: string;
    modalTitle?: string;
    searchIcon?: string;
    search?: string;
    folder: string;
  };
  submitText?: string;
  submitBtnDisabled?: boolean;
  moduleName: string;
  onSearchKeyword?: (params: { searchKeyword: string }) => void;
  onSelectedFolderChange?: (params: {
    searchKeyword: string;
    folder: FolderPrimaryListDto;
  }) => void;
  onSelectedFormatChange?: (params: {
    format: Partial<QueryManagementFormat>;
  }) => void;
  formatNameSearchPlaceholder?: string;
  formatDescriptionSearchPlaceholder?: string;
};
